import { render } from "./surveyed.vue?vue&type=template&id=203a643c&scoped=true&bindings={\"list\":\"props\",\"isLastPage\":\"props\",\"teacherListLoading\":\"props\",\"radio\":\"setup\",\"onRadio\":\"setup\",\"loading\":\"setup\",\"finished\":\"setup\",\"loadRemote\":\"setup\",\"refreshing\":\"setup\",\"onRefresh\":\"setup\"}"
import script from "./surveyed.vue?vue&type=script&lang=ts"
export * from "./surveyed.vue?vue&type=script&lang=ts"

import "./surveyed.vue?vue&type=style&index=0&id=203a643c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-203a643c"

export default script